// extracted by mini-css-extract-plugin
export var contentBody = "_84-9";
export var headerImage = "_84-2";
export var imageButton = "_84-7";
export var imageButtonIcon = "_84-8";
export var imageHeader = "_84-4";
export var imageHeaderText = "_84-5";
export var imageOverlay = "_84-3";
export var imageTitle = "_84-6";
export var imageWrapper = "_84-1";
export var taskList = "_84-a";
export var widget = "_84-0";